// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"97":"8ece6b03","248":"7f094376","481":"d962c81c","981":"d962c81c"}[chunkId] + ".css";
};